import Header from "./components/Header";
import SummaryCards from "./components/SummaryCards";
import ProgressCard from "./components/ProgressCard";
import FilterToolbar from "./components/FilterToolbar";
import BeginningBalanceTable from "./components/BeginningBalanceTable";
import Pagination from "./components/Pagination";
import RecentActivity from "./components/RecentActivity";

import {
    summaryData,
    progressData,
    warehouseList,
    rackList,
    activityData,
    beginningBalanceList,
} from "./components/dummyData";

export default function BeginningBalanceList() {
    return (
        <div className="min-h-screen bg-slate-100 p-6">

            {/* Header */}
            <Header />

            {/* Summary */}
            {/*<SummaryCards />*/}

            {/* Filter */}
            <FilterToolbar />

            <BeginningBalanceTable
                data={beginningBalanceList}
            />
            <Pagination
                currentPage={1}
                totalPages={10}
                totalData={250}
            />

            {/*<div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 xl:col-span-9">
                    <ProgressCard />
                    <BeginningBalanceTable
                        data={beginningBalanceList}
                    />
                    <Pagination
                        currentPage={1}
                        totalPages={10}
                        totalData={250}
                    />
                </div>

                <div className="col-span-12 xl:col-span-3">
                    <RecentActivity />
                </div>
            </div>*/}

        </div>
    );
}